import { client } from '@trello/graphql';
import { getLocation } from '@trello/router';
import { navigate } from '@trello/router/navigate';
import { getCardUrl } from '@trello/urls';

import type { CardUrlFragment } from './CardUrlFragment.generated';
import { CardUrlFragmentDoc } from './CardUrlFragment.generated';

export const openCardBack = async (cardId: string) => {
  const card = client.readFragment<CardUrlFragment>(
    { id: `Card:${cardId}`, fragment: CardUrlFragmentDoc },
    true,
  );

  const cardUrl = getCardUrl({
    url: card?.url,
    id: cardId,
    name: card?.name,
    idShort: card?.idShort,
    idBoard: card?.idBoard,
  });
  const location = getLocation();

  navigate(`${cardUrl}${location.search}`, { trigger: true });
};
